import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert,
  Box
} from '@mui/material';
import api from '../utils/Api';

const CreditSmsModal = ({ open, onClose, school, onCreditSuccess }) => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      setError('Please enter a valid positive number');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await api.post(`/super-admin/schools/${school._id}/credit-sms`, {
        amount: Number(amount)
      });
      
      setSuccess(`Successfully credited ${amount} SMS units to ${school.name}`);
      setTimeout(() => {
        onCreditSuccess();
        handleClose();
      }, 1500);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Failed to credit SMS balance');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAmount('');
    setError('');
    setSuccess('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={!loading ? handleClose : undefined} maxWidth="xs" fullWidth>
      <DialogTitle>Credit SMS Balance</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add SMS credits to <strong>{school?.name}</strong>'s internal balance. This allows them to send messages using your master Arkesel account.
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <TextField
            fullWidth
            label="Number of SMS Units"
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            disabled={loading || !!success}
            InputProps={{ inputProps: { min: 1 } }}
            required
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading || !!success}>Cancel</Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
            disabled={loading || !!success}
          >
            {loading ? <CircularProgress size={24} /> : 'Add Credits'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreditSmsModal;
